/* =============================================================================
   Private Sector — motion layer
   - scroll reveals (.ps-rv, .ps-fig, .ps-rd, .ps-st, [data-ps-band], product cards .ps-dc)
   - text decode (scramble → lock) on .ps-dtx and hover on .ps-cta / nav
   - hero intro (curtain → headline → un-redact → sub → CTA)
   - header hide-on-scroll-down, mobile drawer un-redact stagger
   - product page: rating threshold, eyebrow, sticky bar cooperation
   No dependencies. Safe to remove with ps-motion.css.
   ============================================================================= */
(function () {
  'use strict';
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('ps-js');
  var GL = 'ABCDEFGHJKLMNPRSTUVWXYZ0123456789#%/*';

  /* ---------- text decode (width-locked so layout never jitters) ---------- */
  function decode(el, dur, done) {
    var fin = el.getAttribute('data-fin');
    if (fin == null) { fin = el.textContent; el.setAttribute('data-fin', fin); }
    if (rm) { el.textContent = fin; done && done(); return; }
    var s = performance.now(), w0 = el.offsetWidth;
    if (getComputedStyle(el).display === 'inline') el.style.display = 'inline-block';
    el.style.width = w0 + 'px'; el.style.whiteSpace = 'nowrap'; el.style.overflow = 'hidden'; el.style.verticalAlign = 'bottom';
    function step(t) {
      var e = Math.max(0, Math.min(1, (t - s) / dur)), lock = Math.floor(e * fin.length), o = '';
      for (var i = 0; i < fin.length; i++) { var c = fin[i]; o += (c === ' ' || c === '&' || c === '.' || i < lock) ? c : GL[Math.floor(Math.random() * GL.length)]; }
      el.textContent = o;
      if (e < 1) requestAnimationFrame(step);
      else { el.textContent = fin; el.style.width = ''; el.style.overflow = ''; el.style.whiteSpace = ''; done && done(); }
    }
    requestAnimationFrame(step);
  }
  window.psDecode = decode;

  /* ---------- scroll reveals ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target; el.classList.add('in'); io.unobserve(el);
      if (el.classList.contains('ps-dtx-slow')) setTimeout(function () { decode(el, 900); }, 150);
      var dt = el.querySelectorAll('.ps-dtx'); var bi = parseFloat(getComputedStyle(el).getPropertyValue('--i')) || 0;
      dt.forEach(function (d, k) { setTimeout(function () { decode(d, 650); }, bi * 130 + k * 120 + 350); });
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  // Full-width bands (dark sections with the curtain wipe) are tall, so a % threshold makes the user scroll
  // through a lot of white before the wipe starts. Trigger them on the first visible pixel instead.
  var ioBand = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) return; e.target.classList.add('in'); ioBand.unobserve(e.target); });
  }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });

  function observe(root) {
    (root || document).querySelectorAll('.ps-rv,.ps-fig,.ps-rd,.ps-st,[data-ps-band],.product-block .image-cont.ps-dc').forEach(function (el) {
      if (el.closest('.ps-hero') || el.closest('.mobile-navigation-drawer')) return;
      if (el.classList.contains('in')) return;
      if (el.hasAttribute('data-ps-band')) { ioBand.observe(el); return; }
      io.observe(el);
    });
    // stagger product cards within a grid
    (root || document).querySelectorAll('.product-grid').forEach(function (g) {
      g.querySelectorAll('.product-block').forEach(function (b, i) { var f = b.querySelector('.image-cont.ps-dc'); if (f) f.style.setProperty('--i', i % 6); });
    });
  }
  observe(document);
  // sections injected later (theme editor, quick-buy, fetched content)
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) observe(n); }); }); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); hero(); });

  /* ---------- hero intro ---------- */
  function hero() {
    var h = document.querySelector('.ps-hero'); if (!h || h.dataset.psDone) return; h.dataset.psDone = '1';
    var cen = h.querySelector('.ps-hero__cen'), steps = h.querySelectorAll('.ps-hin'), rd = h.querySelector('.ps-rd');
    if (rm) { steps.forEach(function (s) { s.classList.add('in'); }); rd && rd.classList.add('in'); cen && cen.classList.add('in'); return; }
    var t = [0, 650, 1250, 1900, 2500];
    setTimeout(function () { cen && cen.classList.add('in'); }, 80);
    steps.forEach(function (s) { var k = +s.getAttribute('data-step') || 1; setTimeout(function () { s.classList.add('in'); }, t[Math.min(k, 4)]); });
    setTimeout(function () { rd && rd.classList.add('in'); }, 1750);
  }
  function start() { hero(); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(start); else start();

  /* ---------- parallax on [data-ps-plx] (inside overflow:hidden parents) ---------- */
  var plx = [].slice.call(document.querySelectorAll('[data-ps-plx]'));
  function tick() {
    var vh = innerHeight;
    plx.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh; var amt = parseFloat(el.getAttribute('data-ps-plx')) * vh;
      el.style.transform = 'translate3d(0,' + (-c * amt).toFixed(1) + 'px,0)';
    });
    requestAnimationFrame(tick);
  }
  if (!rm && plx.length) requestAnimationFrame(tick);

  /* ---------- depth-layered hero: background and subject move at different rates (scroll + pointer) ---------- */
  (function () {
    var L = [].slice.call(document.querySelectorAll('[data-ps-layers]')); if (!L.length) return;
    if (rm) { L.forEach(function (w) { w.querySelectorAll('img').forEach(function (i) { i.style.transform = 'scale(1.08)'; }); }); return; }
    L.forEach(function (w) { w.classList.add('ps-intro'); });
    var mx = 0, my = 0, fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
    if (fine) addEventListener('mousemove', function (e) { mx = e.clientX / innerWidth - .5; my = e.clientY / innerHeight - .5; }, { passive: true });
    function frame() {
      L.forEach(function (w) {
        var sec = w.parentElement, r = sec.getBoundingClientRect(); if (r.bottom < 0) return;
        var p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height)));
        var bg = w.querySelector('.ps-l-bg'), fg = w.querySelector('.ps-l-fg'); if (!bg || !fg) return;
        bg.style.transform = 'translate3d(' + (mx * -10).toFixed(1) + 'px,' + (p * -28 + my * -6).toFixed(1) + 'px,0) scale(' + (1.14 - p * 0.02).toFixed(4) + ')';
        fg.style.transform = 'translate3d(' + (mx * 14).toFixed(1) + 'px,' + (p * -90 + my * 8).toFixed(1) + 'px,0) scale(' + (1.06 - p * 0.03).toFixed(4) + ')';
      });
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    setTimeout(function () { L.forEach(function (w) { w.classList.remove('ps-intro'); }); }, 2800);
  })();

  /* ---------- collection hero button: scroll to the grid ---------- */
  document.querySelectorAll('.ps-chead .ps-cta[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href')) || document.querySelector('.ps-main-collection .collection-listing') || document.querySelector('.ps-main-collection');
      if (!t) return; e.preventDefault();
      var y = t.getBoundingClientRect().top + scrollY - 8;
      scrollTo({ top: y, behavior: rm ? 'auto' : 'smooth' });
    });
  });

  /* ---------- keep-going tile: scroll to the section after the grid ---------- */
  document.querySelectorAll('[data-ps-scroll-next]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var sec = a.closest('.shopify-section'); var next = sec && sec.nextElementSibling;
      while (next && next.offsetHeight < 10) next = next.nextElementSibling;
      if (!next) return; e.preventDefault();
      scrollTo({ top: next.getBoundingClientRect().top + scrollY, behavior: rm ? 'auto' : 'smooth' });
    });
  });

  /* ---------- CTA + nav decode on hover ---------- */
  function hoverDecode(el, lab) {
    var busy = false;
    el.addEventListener('mouseenter', function () { if (busy || rm) return; busy = true; decode(lab, 480, function () { busy = false; }); });
  }
  document.querySelectorAll('.ps-cta, .ps-hlink').forEach(function (el) { var lab = el.querySelector('.ps-lab'); if (lab) hoverDecode(el, lab); });
  document.querySelectorAll('.pageheader .navigation__tier-1 > .navigation__item > .navigation__link').forEach(function (a) {
    if (a.querySelector('.ps-nl')) return;
    var txt = a.textContent.trim(); if (!txt) return;
    a.innerHTML = '<span class="ps-nl">' + txt.replace(/</g, '&lt;') + '</span>';
    hoverDecode(a, a.querySelector('.ps-nl'));
  });
  document.querySelectorAll('.pageheader .logo-area__right a').forEach(function (a) {
    var lab = a.querySelector('.header-account-link__text, .show-search-link__text, .cart-link__label'); if (!lab || lab.classList.contains('visually-hidden')) return;
    hoverDecode(a, lab);
  });

  /* ---------- header: hide on scroll down, return on scroll up ---------- */
  (function () {
    var last = 0;
    addEventListener('scroll', function () {
      var y = scrollY;
      if (y > 140 && y > last + 4) document.body.classList.add('ps-hdr-hide');
      else if (y < last - 4 || y <= 140) document.body.classList.remove('ps-hdr-hide');
      last = y;
    }, { passive: true });
  })();

  /* ---------- mobile drawer: wrap tier-1 labels in redaction, stagger on open ---------- */
  function prepDrawer() {
    var d = document.querySelector('.mobile-navigation-drawer'); if (!d || d.dataset.psPrepped) return; d.dataset.psPrepped = '1';
    var items = d.querySelectorAll('.navigation__tier-1 > .navigation__item > .navigation__link');
    items.forEach(function (a, i) {
      if (a.querySelector('.ps-rd')) return;
      var txt = a.textContent.trim();
      a.innerHTML = '<span class="ps-rd"><span class="ps-tx">' + txt.replace(/</g, '&lt;') + '</span><span class="ps-bar"></span></span>';
      a.style.setProperty('--i', i);
    });
    var head = d.querySelector('.navigation__mobile-header');
    if (head && !d.querySelector('.ps-drawer-meta')) { var m = document.createElement('div'); m.className = 'ps-drawer-meta'; m.textContent = 'Menu · Luxury, redacted'; head.insertAdjacentElement('afterend', m); }
    var foot = d.querySelector('.mobile-navigation-drawer__footer');
    if (foot && !d.querySelector('.ps-drawer-foot')) {
      var logo = document.querySelector('.pageheader .ps-logo');
      var f = document.createElement('div'); f.className = 'ps-drawer-foot';
      f.innerHTML = (logo ? logo.outerHTML : '');
      foot.insertAdjacentElement('beforebegin', f);
    }
  }
  var bodyObs = new MutationObserver(function () {
    prepDrawer();
    var open = document.body.classList.contains('reveal-mobile-nav');
    var d = document.querySelector('.mobile-navigation-drawer'); if (!d) return;
    var rds = d.querySelectorAll('.navigation__tier-1 > .navigation__item > .navigation__link .ps-rd');
    if (open) { rds.forEach(function (r, i) { r.classList.remove('in'); setTimeout(function () { r.classList.add('in'); }, 520 + i * 90); }); }
    else rds.forEach(function (r) { r.classList.remove('in'); });
  });
  bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  prepDrawer();

  /* ---------- Junip review carousel → PS reviews block ---------- */
  function junip() {
    document.querySelectorAll('.junip-review-carousel').forEach(function (c) {
      if (c.dataset.psJr) return;
      var items = c.querySelectorAll('.junip-review-carousel-item'); if (!items.length) return;
      c.dataset.psJr = '1'; c.classList.add('ps-jr');
      var cntEl = c.querySelector('.junip-review-carousel-summary-review-count');
      var n = parseInt(((cntEl && cntEl.textContent) || '').replace(/\D/g, ''), 10) || items.length;
      var avgEl = c.querySelector('.junip-review-carousel-rating-average');
      var avg = parseFloat(avgEl && avgEl.textContent) || 0;
      if (avgEl) { avgEl.textContent = avg.toFixed(1); var st = document.createElement('span'); st.className = 'ps-jr__stars'; st.setAttribute('aria-hidden', 'true'); var r = Math.round(avg), o = ''; for (var i = 0; i < 5; i++) o += i < r ? '\u2605' : '\u2606'; st.textContent = o; avgEl.insertAdjacentElement('afterend', st); }
      var sum = c.querySelector('.junip-review-carousel-summary');
      if (sum) { var m = document.createElement('div'); m.className = 'ps-jr__meta'; m.innerHTML = '<span><b>Reviews</b></span><span>Verified buyers</span>'; sum.insertAdjacentElement('beforebegin', m); }
      items.forEach(function (it) {
        var tt = it.querySelector('.junip-review-carousel-item-title'), full = it.getAttribute('aria-label');
        if (tt && full && /(\u2026|\.\.\.)\s*$/.test(tt.textContent)) tt.textContent = full;
        var pr = it.querySelector('.junip-review-product'); if (!pr) return;
        var t = pr.textContent.replace(/^\s*Review for\s*/i, '').trim(); var k = t.lastIndexOf(' - ');
        if (k > -1) { pr.textContent = t.slice(k + 3).trim(); } else pr.classList.add('ps-jr__hide');
      });
      var cap = window.matchMedia('(max-width: 899.98px)').matches ? 3 : 6;
      if (items.length > cap && !c.querySelector('.ps-jr__more')) {
        var w = document.createElement('div'); w.className = 'ps-jr__more';
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ps-cta ghost'; b.innerHTML = '<span class="ps-lab">Show all ' + n + ' reviews</span><span class="ps-arw">&rarr;</span>';
        b.addEventListener('click', function () { c.classList.add('ps-jr--all'); w.remove(); });
        w.appendChild(b); c.appendChild(w);
        var lab = b.querySelector('.ps-lab'); hoverDecode(b, lab);
      }
    });
  }
  junip();
  new MutationObserver(junip).observe(document.body, { childList: true, subtree: true });

  /* ---------- detail carousel (collection materials) ---------- */
  document.querySelectorAll('[data-ps-dcar]').forEach(function (c) {
    var tr = c.querySelector('.ps-dcar__track'); if (!tr) return;
    function go(d) { var s = tr.querySelector('.ps-dcar__s'); if (!s) return; tr.scrollBy({ left: d * (s.getBoundingClientRect().width + 14), behavior: rm ? 'auto' : 'smooth' }); }
    var p = c.querySelector('[data-prev]'), n = c.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { go(-1); });
    if (n) n.addEventListener('click', function () { go(1); });
  });

  /* ---------- collection quotes: live from Junip (5 star only, shuffled, scrollable) ---------- */
  document.querySelectorAll('.ps-quotes[data-ps-junip-key]').forEach(function (sec) {
    var key = sec.getAttribute('data-ps-junip-key'), titles = (sec.getAttribute('data-ps-titles') || '').split('|').filter(Boolean);
    var minStars = parseInt(sec.getAttribute('data-ps-min-stars') || '5', 10), ex = (sec.getAttribute('data-ps-exclude') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var grid = sec.querySelector('.ps-quotes__grid'); if (!key || !grid) return;
    fetch('https://api.juniphq.com/v1/product_reviews?page[size]=100&include=customer', { headers: { 'Junip-Store-Key': key } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.product_reviews) return;
        var rows = j.product_reviews.filter(function (p) {
          if (p.rating < minStars || !p.body) return false;
          var t = p.target_title || '';
          if (titles.length && !titles.some(function (x) { return t.indexOf(x) === 0; })) return false;
          var c = p.customer || {}; var nm = ((c.first_name || '') + ' ' + (c.last_name || '').slice(0, 1)).trim();
          return !ex.some(function (e) { return nm.toLowerCase() === e || (c.first_name || '').toLowerCase() === e; });
        });
        for (var i = rows.length - 1; i > 0; i--) { var k = Math.floor(Math.random() * (i + 1)); var tmp = rows[i]; rows[i] = rows[k]; rows[k] = tmp; }
        // photo reviews first; then pins: "first" titles to the front, "last" titles to the end of the photo group
        var firstT = (sec.getAttribute('data-ps-first') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
        var lastT = (sec.getAttribute('data-ps-last') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
        function hasPhoto(p) { return (p.photo_urls || []).length > 0; }
        function rank(p) { var t = (p.title || '').trim().toLowerCase(); if (firstT.indexOf(t) > -1) return 0; if (lastT.indexOf(t) > -1) return 2; return hasPhoto(p) ? 1 : 3; }
        rows = rows.map(function (p, i) { return { p: p, i: i }; }).sort(function (a, b) { return rank(a.p) - rank(b.p) || a.i - b.i; }).map(function (x) { return x.p; });
        if (rows.length < 1) return;
        function trim(s) { s = s.replace(/\s+/g, ' ').trim(); if (s.length <= 220) return s; var cut = s.slice(0, 220); var q = Math.max(cut.lastIndexOf('. '), cut.lastIndexOf('! ')); return (q > 90 ? cut.slice(0, q + 1) : cut.replace(/\s\S*$/, '') + '\u2026'); }
        function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
        grid.innerHTML = rows.map(function (p, i) {
          var c = p.customer || {}; var nm = ((c.first_name || '') + ' ' + (c.last_name || '').slice(0, 1)).trim() || 'Verified buyer';
          var prod = (p.target_title || '').split(' - ')[0]; var stars = ''; for (var k = 0; k < 5; k++) stars += k < p.rating ? '\u2605' : '\u2606';
          var ph = (p.photo_urls || []).map(function (u) { if (typeof u === 'string') return { large: u, thumbnail: u }; return u && (u.large || u.thumbnail) ? { large: u.large || u.thumbnail, thumbnail: u.thumbnail || u.large } : null; }).filter(function (u) { return u && /^https?:/.test(u.large); }).slice(0, 3);
          var media = ph.length ? '<div class="ps-q__media">' + ph.map(function (u) { return '<button type="button" class="ps-q__ph" data-ps-lightbox="' + esc(u.large) + '" aria-label="View customer photo"><img src="' + esc(u.thumbnail) + '" alt="Customer photo" loading="lazy"></button>'; }).join('') + '</div>' : '';
          return '<article class="ps-q ps-rv in" style="--i:' + Math.min(i, 3) + '"><div class="ps-q__stars" aria-label="' + p.rating + ' out of 5 stars">' + stars + '</div>' + (p.title ? '<h4>' + esc(p.title) + '</h4>' : '') + '<p>' + esc(trim(p.body)) + '</p>' + media + '<footer><span>' + esc(nm) + '</span><span>' + esc(prod) + '</span></footer></article>';
        }).join('');
        grid.classList.add('ps-quotes__grid--scroll');
        // arrows + progress
        var nav = sec.querySelector('.ps-quotes__nav');
        if (!nav) {
          nav = document.createElement('div'); nav.className = 'ps-quotes__nav';
          nav.innerHTML = '<div class="ps-quotes__bar"><i></i></div><button type="button" data-prev aria-label="Previous">&larr;</button><button type="button" data-next aria-label="Next">&rarr;</button>';
          sec.appendChild(nav);
        }
        var bar = nav.querySelector('.ps-quotes__bar i');
        function step(d) { var card = grid.querySelector('.ps-q'); if (!card) return; grid.scrollBy({ left: d * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(grid).columnGap || 24)), behavior: rm ? 'auto' : 'smooth' }); }
        nav.querySelector('[data-prev]').addEventListener('click', function () { step(-1); });
        nav.querySelector('[data-next]').addEventListener('click', function () { step(1); });
        function prog() { var max = grid.scrollWidth - grid.clientWidth; var w = Math.max(0.12, grid.clientWidth / grid.scrollWidth); bar.style.width = (w * 100).toFixed(1) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (grid.scrollLeft / max) * ((1 - w) / w) * 100 : 0).toFixed(1) + '%)'; nav.classList.toggle('ps-quotes__nav--off', max < 4); }
        grid.addEventListener('scroll', prog, { passive: true }); addEventListener('resize', prog); prog();
      }).catch(function () {});
  });

  /* ---------- lightbox for review photos ---------- */
  (function () {
    var box = null, img = null, cap = null, timer = null, lastFocus = null;
    function close() {
      if (!box || box.hidden) return;
      box.classList.remove('in'); document.body.classList.remove('ps-lightbox-open');
      clearTimeout(timer); timer = setTimeout(function () { box.hidden = true; img.removeAttribute('src'); }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function build() {
      box = document.createElement('div'); box.className = 'ps-lightbox'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.hidden = true;
      box.innerHTML = '<div class="ps-lightbox__veil"></div><figure class="ps-lightbox__fig"><img alt=""><figcaption></figcaption></figure><button type="button" class="ps-lightbox__close" aria-label="Close"><span aria-hidden="true">&times;</span><span class="ps-lightbox__closelab">Close</span></button>';
      document.body.appendChild(box); img = box.querySelector('img'); cap = box.querySelector('figcaption');
      // Tap anywhere (veil, image, caption, button) closes. Only the image can also be pinch-zoomed by the browser.
      box.addEventListener('click', function (e) { e.preventDefault(); close(); });
      addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      // Swipe down to dismiss on touch
      var y0 = null;
      box.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
      box.addEventListener('touchend', function (e) { if (y0 !== null && e.changedTouches[0].clientY - y0 > 70) close(); y0 = null; }, { passive: true });
      // Safety net: if the page is navigated back to (bfcache), never come back with the overlay stuck
      addEventListener('pageshow', function () { box.hidden = true; box.classList.remove('in'); document.body.classList.remove('ps-lightbox-open'); });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ps-lightbox]'); if (!b) return;
      e.preventDefault(); if (!box) build(); clearTimeout(timer); lastFocus = b;
      var q = b.closest('.ps-q'); var who = q ? (q.querySelector('footer span') || {}).textContent || '' : '';
      var prod = q ? ((q.querySelectorAll('footer span')[1] || {}).textContent || '') : '';
      img.src = b.getAttribute('data-ps-lightbox'); cap.textContent = (who + (prod ? ' \u00b7 ' + prod : '')).trim();
      box.hidden = false; document.body.classList.add('ps-lightbox-open');
      requestAnimationFrame(function () { box.classList.add('in'); box.querySelector('.ps-lightbox__close').focus(); });
    });
  })();

  /* ---------- product page ---------- */
  (function () {
    var info = document.querySelector('.product-info'); if (!info) return;
    // decode title on load
    var title = info.querySelector('.product-title'); if (title && !rm) { title.classList.add('ps-dtx-slow'); setTimeout(function () { decode(title, 900); }, 250); }
    // Junip star row: hide until threshold (theme-side threshold is in main-product.liquid; this covers app-rendered stars)
    var thrEl = info.querySelector('[data-ps-rating-threshold]'); var thr = parseInt((thrEl && thrEl.getAttribute('data-ps-rating-threshold')) || '5', 10);
    function applyThreshold() {
      info.querySelectorAll('.junip-product-summary, .junip-product-summary-stars, [class*="junip-product-summary"]').forEach(function (w) {
        var m = (w.textContent || '').match(/(\d+)\s*review/i); var n = m ? parseInt(m[1], 10) : 0;
        var host = w.closest('.junip-product-summary') || w;
        host.classList.toggle('ps-rating--hidden', n < thr);
      });
    }
    applyThreshold();
    new MutationObserver(applyThreshold).observe(info, { childList: true, subtree: true });
  })();
})();
